import {createFeatureSelector, createSelector} from '@ngrx/store';
import {State} from './multiview.delete-many.reducer';
import {Multiview} from '../../../services/api/multiviews/multiview-viewer.model';

export const deleteManyMultiviewsFeatureKey = 'deleteManyDestinations';
export const featureSelector = createFeatureSelector<State>(deleteManyMultiviewsFeatureKey);

export const getDeleteManyMultiviewsRecord = createSelector(
  featureSelector,
  (state: State): Multiview[] => state.record
);

export const getDeleteManyMultiviewsLoaded = createSelector(
  featureSelector,
  (state: State): boolean => state.loaded
);

export const getDeleteManyMultiviewsLoading = createSelector(
  featureSelector,
  (state: State): boolean => state.loading
);

export const getDeleteManyMultiviewsError = createSelector(
  featureSelector,
  (state: State): any => state.error
);
